import React, { createContext, useContext } from 'react';
import { useAuth as useAuthHook } from '../features/auth/hooks/useAuth';
import { AuthState, User, MenuPermission, LoginResponse } from '../features/auth/types';

interface AuthContextType extends AuthState {
  login: (loginResponse: LoginResponse) => Promise<void>;
  logout: () => Promise<void>;
  sendOtp: (mobileNo: string) => Promise<{ session_id: string; message: string; }>;
  verifyOtp: (sessionId: string, otp: string) => Promise<LoginResponse>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const auth = useAuthHook();
  
  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
};
